module.exports = __webpack_public_path__ + "static/media/photo_custom_fabrication.f1cc3198.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SideImage/photo_custom_fabrication.jpg
// module id = 391
// module chunks = 0